import { OverlayConfig, Overlay, OverlayModule } from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector, PortalModule } from '@angular/cdk/portal';
import { InjectionToken, Component, ViewChild, ViewContainerRef, ɵɵdefineInjectable, ɵɵinject, INJECTOR, Injectable, Injector, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { trigger, transition, style, animate } from '@angular/animations';
import { CommonModule } from '@angular/common';

/** @format */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/cdk/portal';
import * as ɵngcc2 from '@angular/cdk/overlay';

const _c0 = ["place"];
function ModuleWrapperComponent_ng_template_2_Template(rf, ctx) { }
const MODAL_DATA_VAR = new InjectionToken("MISModalDataInjectionToken");

/** @format */
class ModalRef {
    constructor(overlay) {
        this.overlay = overlay;
        this.afterClosed$ = new Subject();
        this.afterClosed = this.afterClosed$.asObservable();
    }
    close(data) {
        this.overlay.detach();
        this.overlay.dispose();
        this.afterClosed$.next(data);
        this.afterClosed$.complete();
    }
}

class ModuleWrapperComponent {
    constructor() { }
    bindComponent(type, injector) {
        this.initComponent(type, injector);
    }
    initComponent(type, injector) {
        this.modalPortal = new ComponentPortal(type, this.place, injector);
    }
}
ModuleWrapperComponent.ɵfac = function ModuleWrapperComponent_Factory(t) { return new (t || ModuleWrapperComponent)(); };
ModuleWrapperComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ModuleWrapperComponent, selectors: [["mis-module-wrapper"]], viewQuery: function ModuleWrapperComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.place = _t.first);
    } }, decls: 3, vars: 2, consts: [[1, "mis-modal-body"], ["place", ""], [3, "cdkPortalOutlet"]], template: function ModuleWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, ModuleWrapperComponent_ng_template_2_Template, 0, 0, "ng-template", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("@slideInOut", undefined);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("cdkPortalOutlet", ctx.modalPortal);
    } }, dependencies: [ɵngcc1.CdkPortalOutlet], styles: [".mis-modal-body[_ngcontent-%COMP%]{display:block;width:100%;height:100%;background-color:transparent;border-radius:12px;box-shadow:0 12px 24px rgba(0,0,0,.12),0 4px 8px rgba(0,0,0,.12);overflow:hidden}"], data: { animation: [
            trigger("slideInOut", [
                transition(":enter", [
                    style({ transform: "translateY(-30%)", opacity: 0 }),
                    animate("200ms ease-out", style({ transform: "translatey(0%)", opacity: 1 }))
                ]),
                transition(":leave", [animate("200ms ease-out", style({ transform: "translatey(-30%)", opacity: 0 }))])
            ])
        ] } });
ModuleWrapperComponent.ctorParameters = () => [];
ModuleWrapperComponent.propDecorators = {
    place: [{ type: ViewChild, args: ["place", { static: false, read: ViewContainerRef },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModuleWrapperComponent, [{
        type: Component,
        args: [{ selector: "mis-module-wrapper", template: "<div class=\"mis-modal-body\" #place @slideInOut>\n  <ng-template [cdkPortalOutlet]=\"modalPortal\"></ng-template>\n</div>\n", animations: [
                    trigger("slideInOut", [
                        transition(":enter", [
                            style({ transform: "translateY(-30%)", opacity: 0 }),
                            animate("200ms ease-out", style({ transform: "translatey(0%)", opacity: 1 }))
                        ]),
                        transition(":leave", [animate("200ms ease-out", style({ transform: "translatey(-30%)", opacity: 0 }))])
                    ])
                ], styles: [".mis-modal-body{display:block;width:100%;height:100%;background-color:transparent;border-radius:12px;box-shadow:0 12px 24px rgba(0,0,0,.12),0 4px 8px rgba(0,0,0,.12);overflow:hidden}"] }]
    }], function () { return []; }, { place: [{
            type: ViewChild,
            args: ["place", { static: false, read: ViewContainerRef }]
        }] }); })();

class ModalService {
    constructor(overlay, injector) {
        this.overlay = overlay;
        this.injector = injector;
    }
    show(component, data, options) {
        const positionStrategy = this.calculatePosition(options);
        const { width, height } = options || {};
        const config = new OverlayConfig({
            hasBackdrop: true,
            positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.noop(),
            width: width,
            height,
            panelClass: "mis-modal",
            backdropClass: "mis-modal-overlay"
        });
        const overlayRef = this.overlay.create(config);
        const modalRef = new ModalRef(overlayRef);
        const injector = this.createInjector(modalRef, this.injector, data);
        const portal = new ComponentPortal(ModuleWrapperComponent, null);
        this.componentInstance = overlayRef.attach(portal);
        if (options === null || options === void 0 ? void 0 : options.closeOnBackdropClick) {
            overlayRef.backdropClick().subscribe(() => modalRef.close());
        }
        this.componentInstance.instance.bindComponent(component, injector);
        return modalRef;
    }
    createInjector(ref, inj, data) {
        const injectorTokens = new WeakMap();
        injectorTokens.set(ModalRef, ref);
        injectorTokens.set(MODAL_DATA_VAR, data);
        return new PortalInjector(inj, injectorTokens);
    }
    calculatePosition(options) {
        const position = this.overlay.position().global().centerHorizontally().centerVertically();
        if (options && screen.width > 600) {
            if (options.top) {
                position.top(options.top);
            }
            if (options.left) {
                position.left(options.left);
            }
            if (options.right) {
                position.right(options.right);
            }
            if (options.bottom) {
                position.bottom(options.bottom);
            }
        }
        return position;
    }
}
ModalService.ɵfac = function ModalService_Factory(t) { return new (t || ModalService)(ɵngcc0.ɵɵinject(ɵngcc2.Overlay), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
ModalService.ɵprov = ɵɵdefineInjectable({ factory: function ModalService_Factory() { return new ModalService(ɵɵinject(Overlay), ɵɵinject(INJECTOR)); }, token: ModalService, providedIn: "root" });
ModalService.ctorParameters = () => [
    { type: Overlay },
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: ɵngcc2.Overlay }, { type: ɵngcc0.Injector }]; }, null); })();

class ModalModule {
    static forRoot() {
        return {
            ngModule: ModalModule,
            providers: [ModalService]
        };
    }
    static forChild() {
        return {
            ngModule: ModalModule,
            providers: [ModalService]
        };
    }
}
ModalModule.ɵfac = function ModalModule_Factory(t) { return new (t || ModalModule)(); };
ModalModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ModalModule });
ModalModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, OverlayModule, PortalModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalModule, [{
        type: NgModule,
        args: [{
                declarations: [ModuleWrapperComponent],
                imports: [CommonModule, OverlayModule, PortalModule],
                entryComponents: [ModuleWrapperComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ModalModule, { declarations: function () { return [ModuleWrapperComponent]; }, imports: function () { return [CommonModule, OverlayModule, PortalModule]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MODAL_DATA_VAR, ModalModule, ModalRef, ModalService, ModuleWrapperComponent as ɵa };

